import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../MultiSelectBox/MultiSelectBox'

const ChooseSubscriptionForm = ({ subscriptions, onSuccess }) => {

    const onChange = (id) => {
        id = parseInt(id);
        const subscription = subscriptions.find((item) => item.id === id);
        onSuccess(subscription);
    }

    return (
        <div className="choose-subscription-form">
            <MultiSelectBox
                name="Subscriptions"
                placeholder="Select a subscription..."
                options={subscriptions}
                idField="id"
                valueField="name"
                selectedValues=""
                onChange={onChange}
                defaultValue='Select a Subscription...'
                isMulti={false}
                isFocused={true} />
        </div>
    );
};

ChooseSubscriptionForm.propTypes = {
    subscriptions: PropTypes.array.isRequired,
    onSuccess: PropTypes.func.isRequired
}

export default ChooseSubscriptionForm;
